/* Spring Reset Challenge popup. Markup and gating: snippets/src-popup.liquid. */
(function () {
  var popup = document.querySelector('[data-src-popup]');
  if (!popup) return;

  var COOKIE = 'src_popup_closed';
  var COOKIE_MAX_AGE = 7 * 24 * 60 * 60;
  var DELAY_MS = 5000;
  var SCROLL_DEPTH = 0.5;
  var GA4_ID = 'G-Y0VT2QGQW7';

  function hasCookie() {
    return document.cookie.split('; ').some(function (c) {
      return c.indexOf(COOKIE + '=') === 0;
    });
  }

  if (hasCookie() && !/[?&]src_popup=force\b/.test(location.search)) return;

  var dialog = popup.querySelector('[role="dialog"]');
  var cta = popup.querySelector('[data-src-popup-cta]');
  var addVariant = popup.getAttribute('data-add-variant');
  var toCheckout = popup.hasAttribute('data-checkout');
  var dismissOnly = popup.hasAttribute('data-src-popup-dismiss');
  var shown = false;
  var timer = null;
  var lastFocus = null;

  function setCookie() {
    var domain = /(^|\.)fitazfk\.com$/.test(location.hostname) ? '; domain=.fitazfk.com' : '';
    document.cookie = COOKIE + '=1; max-age=' + COOKIE_MAX_AGE + '; path=/' + domain + '; SameSite=Lax';
  }

  function gtag() {
    if (typeof window.gtag === 'function') {
      window.gtag.apply(window, arguments);
      return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
  }

  function track(name, params) {
    var payload = {
      send_to: GA4_ID,
      site_market: popup.getAttribute('data-market'),
      page_type: popup.getAttribute('data-page-type'),
      popup_action: dismissOnly ? 'dismiss' : toCheckout ? 'checkout' : addVariant ? 'add_to_cart' : 'link'
    };
    for (var k in params) payload[k] = params[k];
    gtag('event', name, payload);
  }

  function drawerOpen() {
    var drawer = document.querySelector('.kozler-cart[data-section-id]');
    return !!(drawer && drawer.classList.contains('is-open'));
  }

  function focusables() {
    return Array.prototype.slice.call(
      dialog.querySelectorAll('a[href], button:not([disabled])')
    ).filter(function (el) {
      return el.offsetParent !== null;
    });
  }

  function onKeydown(e) {
    if (e.key === 'Escape') {
      close('escape');
      return;
    }
    if (e.key !== 'Tab') return;
    var items = focusables();
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function teardownTriggers() {
    if (timer) window.clearTimeout(timer);
    timer = null;
    window.removeEventListener('scroll', onScroll);
  }

  function show(trigger) {
    if (shown) return;
    if (drawerOpen()) {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () { show(trigger); }, 1000);
      return;
    }
    shown = true;
    teardownTriggers();
    lastFocus = document.activeElement;
    popup.hidden = false;
    document.documentElement.classList.add('src-popup-open');
    document.addEventListener('keydown', onKeydown);
    dialog.focus({ preventScroll: true });
    track('src_popup_view', { popup_trigger: trigger });
  }

  function hide() {
    popup.hidden = true;
    document.documentElement.classList.remove('src-popup-open');
    document.removeEventListener('keydown', onKeydown);
    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus({ preventScroll: true });
    }
  }

  function close(method) {
    if (popup.hidden) return;
    setCookie();
    hide();
    track('src_popup_close', { close_method: method });
  }

  function onScroll() {
    var doc = document.documentElement;
    var scrollable = doc.scrollHeight - window.innerHeight;
    if (scrollable > 0 && window.scrollY / scrollable >= SCROLL_DEPTH) show('scroll');
  }

  popup.addEventListener('click', function (e) {
    var closer = e.target.closest('[data-src-popup-close]');
    if (!closer) return;
    var method = 'backdrop';
    if (closer.classList.contains('src-popup__close--desktop')) method = 'button_desktop';
    else if (closer.classList.contains('src-popup__close--mobile')) method = 'button_mobile';
    close(method);
  });

  cta.addEventListener('click', function (e) {
    if (dismissOnly) {
      e.preventDefault();
      track('src_popup_cta', {
        link_url: '',
        link_text: cta.textContent.trim(),
        cta_destination: 'dismiss',
        transport_type: 'beacon'
      });
      close('cta_stay');
      return;
    }
    setCookie();
    var drawer = window.KozlerCartDrawer;
    var hasDrawer = !!(drawer && typeof drawer.openAndRefresh === 'function');
    var destination = !addVariant ? 'link' : toCheckout ? 'checkout' : hasDrawer ? 'cart_drawer' : 'link';

    track('src_popup_cta', {
      link_url: destination === 'link' ? cta.href : '',
      link_text: cta.textContent.trim(),
      cta_destination: destination,
      transport_type: 'beacon'
    });

    if (destination === 'link') return;

    e.preventDefault();
    cta.setAttribute('aria-busy', 'true');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function add() {
      var item = { id: Number(addVariant), quantity: 1 };
      /* Mirror properties[_funnel] from snippets/tbf-atc-form.liquid so a popup
         add carries the same funnel cohort key as the page's own ATC, and so the
         two paths merge into one cart line instead of two. Funnel host only:
         fitazfk.com forms do not set it. */
      if (/(^|\.)au\.fitazfk\.com$/.test(location.hostname)) {
        item.properties = { _funnel: 'tbf' };
      }
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] })
      }).then(function (res) {
        if (!res.ok) throw new Error('cart add ' + res.status);
      });
    }

    /* Bundle pages check out the bundle alone, same as the page's own CTAs
       (assets/tbf-replace-cart.js): empty the cart, then add. If the clear
       fails, the add still goes ahead. */
    var added = toCheckout
      ? fetch(root + 'cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
        })
          .catch(function () {})
          .then(add)
      : add();

    added
      .then(function () {
        if (toCheckout) {
          window.location.assign(root + 'checkout');
          return;
        }
        hide();
        drawer.openAndRefresh();
      })
      .catch(function () {
        window.location.assign(popup.getAttribute('data-link'));
      })
      .finally(function () {
        cta.removeAttribute('aria-busy');
      });
  });

  Array.prototype.forEach.call(
    popup.querySelectorAll('.src-popup__image, .src-popup__title'),
    function (el) {
      el.style.cursor = 'pointer';
      el.addEventListener('click', function () { cta.click(); });
    }
  );

  if (/[?&]src_popup=force\b/.test(location.search)) {
    show('force');
    return;
  }

  timer = window.setTimeout(function () { show('timer'); }, DELAY_MS);
  window.addEventListener('scroll', onScroll, { passive: true });
})();
